import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { TextField, StyledButton } from "components/support";

import Icon from "material-ui-next/Icon";

class PasswordFieldsView extends Component {
  constructor(props) {
    super(props);
    this.presenter = props.presenter;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.viewModel.mode !== nextProps.mode) {
      this.props.viewModel.mode = nextProps.mode;
      this.props.viewModel.visible = this.props.viewModel.mode === "add";
    }
  }

  onChange = (value, field) => {
    this.props.viewModel[field] = value;
    this.props.onChange(value, field);

    const validation = this.presenter.doValidateField(value, field);

    if (!!validation) {
      for (const key of Object.keys(validation)) {
        validation[key].forEach(error => {
          // Show just the error of current field
          if (key === field) {
            this.props.setFieldError(key, error);
          }
        });
      }
      // If there are validation errors but the current field is correct
      if (!Object.keys(validation).includes(field)) {
        this.props.setFieldError(field, "");
      }
    } else {
      this.props.setFieldError(field, "");
    }
  };

  handleChangeButton = () => {
    this.props.viewModel.visible = true;
    this.props.changePassword();
  };

  render() {
    return (
      <div>
        {!this.props.viewModel.visible && (
          <Row>
            <Col xs={12}>
              <StyledButton
                onClick={this.handleChangeButton}
                label="Alterar Senha"
                leftIcon={
                  <Icon
                    style={{ fontSize: "1.6em", padding: 0, color: "#333" }}
                  >
                    lock_open
                  </Icon>
                }
                style={{ margin: "12px 0px 0px" }}
              />
            </Col>
          </Row>
        )}
        {this.props.viewModel.visible && (
          <Row>
            <Col xs={12} lg={6}>
              <div style={{ paddingRight: "0.5em" }}>
                <TextField
                  fullWidth
                  underlineShow={false}
                  value={this.props.viewModel.password}
                  floatingLabelFixed={true}
                  floatingLabelText="Senha"
                  errorText={this.props.errors.password}
                  type="password"
                  onChange={(event, value) => this.onChange(value, "password")}
                />
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <TextField
                fullWidth
                underlineShow={false}
                value={this.props.viewModel.confirmPassword}
                floatingLabelFixed={true}
                floatingLabelText="Confirmação de Senha"
                errorText={this.props.errors.confirmPassword}
                type="password"
                onChange={(event, value) =>
                  this.onChange(value, "confirmPassword")
                }
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default PasswordFieldsView;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/password-fields/password-fields.view.js